export default __webpack_public_path__ + "static/waxfile-fd44a93098cf17cb53df3e01c1f0c7a5.png";